<app-vertical-bar-graph 
    [graph]="data.graph.data" 
    [selectedColumnIndex]="currentSelectedColumnIndex"
    (onBarSelect)="onSelectGarphValue($event)" 
    [type]="getBarType(data)">
</app-vertical-bar-graph>

<app-eps-footer 
    [epsFooterData]="footerData">
</app-eps-footer>
